var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.863,
    height: 15.957,
    viewBox: "0 0 15.863 15.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "whatsapp",
    d: "M13.634,11.557c-.159-.08-1.2-.558-1.355-.637A.375.375,0,0,0,11.8,11c-.159.159-.478.637-.637.8-.08.159-.239.159-.4.08a6.514,6.514,0,0,1-1.594-.956A9.173,9.173,0,0,1,8.056,9.565a.35.35,0,0,1,.08-.4c.08-.08.159-.239.319-.319a.6.6,0,0,0,.159-.319.242.242,0,0,0,0-.319,14.165,14.165,0,0,1-.637-1.434c-.08-.558-.239-.558-.4-.558h-.4a.909.909,0,0,0-.478.239,2.293,2.293,0,0,0-.717,1.673,4.174,4.174,0,0,0,.8,2.072,8.5,8.5,0,0,0,3.347,2.948,6.246,6.246,0,0,0,1.116.4,2.276,2.276,0,0,0,1.275.08,2.064,2.064,0,0,0,1.355-.956,1.333,1.333,0,0,0,.08-.956l-.319-.159m1.992-7.251A7.943,7.943,0,0,0,3.116,13.868L2,17.932l4.223-1.116A7.873,7.873,0,0,0,17.858,9.884a7.761,7.761,0,0,0-2.231-5.578M13.475,15.462A6.688,6.688,0,0,1,9.969,16.5a6.988,6.988,0,0,1-3.347-.877l-.239-.159-2.47.637.637-2.391-.159-.239A6.691,6.691,0,0,1,6.542,4.306a6.482,6.482,0,0,1,9,2.072,6.575,6.575,0,0,1-2.072,9.084",
    transform: "translate(-2 -1.975)",
    fill: "#b07f4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.56b7453640b919cb62f9e728b4caec6a.svg";
export { ForwardRef as ReactComponent };